// extracted by mini-css-extract-plugin
export default {"table":"table__ypeQiz","formItemHidden":"formItemHidden__u1FKqx","icon":"icon__I65K98","switch":"switch__PPCI7M","button":"button__qMnCBD"};